import { theme } from '@chakra-ui/pro-theme';
import { extendTheme } from '@chakra-ui/react';
import { mobileSafariTheme } from '../utils/mobile-safari-theme';
import '@fontsource-variable/open-sans';
import '@fontsource-variable/spline-sans';

const proTheme = extendTheme(theme);

const extendedConfig = {
  colors: {
    ...proTheme.colors,
    brand: {
      50: '#EBF8FF',
      100: '#BEE3F8',
      200: '#90CDF4',
      300: '#63B3ED',
      400: '#4299E1',
      500: '#0000FF',
      600: '#2B6CB0',
      700: '#2C5282',
      800: '#2A4365',
      900: '#1A365D',
    },
    'brand-violet': {
      50: '#FAF5FF',
      100: '#E9D8FD',
      200: '#D6BCFA',
      300: '#B794F4',
      400: '#9F7AEA',
      500: '#805AD5',
      600: '#6B46C1',
      700: '#553C9A',
      800: '#44337A',
      900: '#322659',
    },
    'light-background': 'rgb(240, 245,250)',
    'dark-background': '#121212',
  },
  fonts: {
    heading: "'Montserrat', sans-serif",
    body: "'Montserrat', sans-serif",
  },
};

const myTheme = extendTheme(extendedConfig, mobileSafariTheme, proTheme);

export default myTheme;
